// 简历管理模块

//初始化内部个人基本资料
function initBaseResume(bid, msg, userid_p) {
  return new Promise(resolve => {
    $.ajax({
      url: APIB,
      async: true,
      type: "post",
      dataType: "json",
      data: { action: "save", bid, pagename: "addpsn", accountInfo: JSON.stringify(msg), userid_p },
      success: res => {
        if (res) {
          const jsonRes = JSON.parse(res);
          jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//保存内部个人基本资料
function saveBaseResume(cuserid, msg) {
  return new Promise(resolve => {
    $.ajax({
      url: APIB,
      async: true,
      type: "post",
      dataType: "json",
      data: { action: "save", cuserid, pagename: "psnbaseinfoinner", msg: JSON.stringify(msg) },
      success: res => {
        if (res) {
          const jsonRes = JSON.parse(res);
          jsonRes.status == "ok" ? resolve(true) : resolve(false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//保存个人简历
function saveResumeInformation(userid, pagename, msg) {
  return new Promise(resolve => {
    $.ajax({
      url: APIB,
      async: true,
      type: "post",
      dataType: "json",
      data: { action: "save", type: "p", cuserid: userid, pagename, msg: JSON.stringify(msg) },
      success: res => {
        const jsonRes = JSON.parse(res);
        jsonRes.status == "ok" ? resolve(true) : resolve(false);
      }
    });
  });
}

//保存标签
function savePersonalTags(cuserid, pagename, msg, act) {
  return new Promise(resolve => {
    $.ajax({
      url: APIB,
      async: true,
      type: "post",
      dataType: "json",
      data: { action: "save", cuserid: cuserid, pagename, msg, act },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      }
    });
  });
}

//保存个人专业技能标签
function addProfessionTags(userid, msg) {
  return new Promise(resolve => {
    $.ajax({
      url: APIPsn,
      async: true,
      type: "post",
      dataType: "json",
      data: { action: "save", type: "p", userid, pagename: "skilltag", msg },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            if (jsonRes.status == "ok") {
              resolve(true);
            } else {
              resolve(false);
            }
          } catch (e) {
            console.log("保存个人专业技能标签出错");
            resolve(false);
          }
        } else {
          console.log("保存个人专业技能标签出错");
          resolve(false);
        }
      }
    });
  });
}

//删除内部资料中的教育经历
function deleteEduHistory(pagename, cuserid, eduinfoid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "del", pagename, userid: Cookies.get("userid-b"), cuserid, eduinfoid },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      }
    });
  });
}

//删除内部资料中的工作经历
function deleteWorkHistory(pagename, cuserid, workinfoid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "del", pagename, userid: Cookies.get("userid-b"), cuserid, workinfoid },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      }
    });
  });
}

export default {
  initBaseResume,
  saveBaseResume,
  saveResumeInformation,
  savePersonalTags,
  addProfessionTags,
  deleteEduHistory,
  deleteWorkHistory
};
